import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Index.vue'),
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    component: () => import('@/components/Layout/Index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        meta: { title: '首页看板', icon: 'el-icon-s-home' }
      },
      {
        path: 'categories',
        name: 'Categories',
        component: () => import('@/views/content/Categories.vue'),
        meta: { title: '大类管理', icon: 'el-icon-folder' }
      },
      {
        path: 'subjects',
        name: 'Subjects',
        component: () => import('@/views/content/Subjects.vue'),
        meta: { title: '科目管理', icon: 'el-icon-folder-opened' }
      },
      {
        path: 'students',
        name: 'Students',
        component: () => import('@/views/students/Index.vue'),
        meta: { title: '学员管理', icon: 'el-icon-user' }
      },
      {
        path: 'students/:id',
        name: 'StudentDetail',
        component: () => import('@/views/students/Detail.vue'),
        meta: { title: '学员详情', hidden: true }
      },
      {
        path: 'courserecord/:id',
        name: 'courseRecordDetail',
        component: () => import('@/views/students/CourseRecords.vue'),
        meta: { title: '学员课程记录', hidden: true }
      },
      {
        path: 'questionrecord/:id',
        name: 'questionRecordsDetail',
        component: () => import('@/views/students/QuestionRecords.vue'),
        meta: { title: '学员题库记录', hidden: true }
      },
      {
        path: 'liverecords/:id',
        name: 'liveRecordsDetail',
        component: () => import('@/views/students/LiveRecords.vue'),
        meta: { title: '学员直播记录', hidden: true }
      },
      {
        path: 'courses',
        name: 'Courses',
        component: () => import('@/views/courses/Index.vue'),
        meta: { title: '课程管理', icon: 'el-icon-notebook-2' }
      },

      {
        path: 'courses/:id/modules',
        name: 'CourseModules',
        component: () => import('@/views/courses/Modules.vue'),
        meta: { title: '课程模块', hidden: true }
      },
      {
        path: 'modules',
        name: 'ModuleList',
        component: () => import('@/views/modules/Index.vue'),
        meta: { title: '模块管理', icon: 'el-icon-menu' }
      },
      {
        path: 'modules/:id/nodes',
        name: 'ModuleNodes',
        component: () => import('@/views/modules/Nodes.vue'),
        meta: { title: '目录管理', hidden: true }
      },
      {
        path: 'learn-records',
        name: 'LearnRecords',
        component: () => import('@/views/learn/Records.vue'),
        meta: { title: '学习记录', icon: 'el-icon-data-line' }
      },
      // 在 children 数组中添加以下路由
      {
        path: 'questions',
        name: 'Questions',
        component: () => import('@/views/questions/Index.vue'),
        meta: { title: '题库管理', icon: 'el-icon-tickets' }
      },
      {
        path: 'questions/edit/:id?',
        name: 'QuestionEdit',
        component: () => import('@/views/questions/Edit.vue'),
        meta: { title: '编辑题目', hidden: true }
      },
      // ✅ 简单方案：直接在children中添加，不用嵌套
      {
        path: 'live',
        name: 'LiveIndex',
        component: () => import('@/views/live/Index.vue'),
        meta: { title: '直播管理', icon: 'el-icon-video-play' }
      },
      {
        path: 'live/create',
        name: 'LiveCreate',
        component: () => import('@/views/live/Edit.vue'),
        meta: { title: '创建直播', hidden: true }
      },
      {
        path: 'live/:id/edit',
        name: 'LiveEdit',
        component: () => import('@/views/live/Edit.vue'),
        meta: { title: '编辑直播', hidden: true }
      },
      {
        path: 'live/access',
        name: 'LiveAccess',
        component: () => import('@/views/live/Access.vue'),
        meta: { title: '直播权限', hidden: true }
      },
      {
        path: 'videos',
        name: 'videos',
        component: () => import('@/views/videos/Index.vue'),
        meta: { title: '视频管理', icon: 'el-icon-video-camera' }
      },
      {
        path: 'handouts',
        name: 'handouts',
        component: () => import('@/views/handouts/Index.vue'),
        meta: { title: '讲义管理', icon: 'el-icon-document' }
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 修复 Vue Router 重复导航报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated') {
      return err
    }
    throw err
  })
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.meta.noAuth) {
    next()
  } else if (!token) {
    next('/login')
  } else if (to.path === '/') {
    // 根路径重定向到 dashboard
    next('/dashboard')
  } else {
    document.title = to.meta.title ? `${to.meta.title} - 管理后台` : '管理后台'
    next()
  }
})

export default router